import { render, staticRenderFns } from "./lessonsTab.vue?vue&type=template&id=6fc8837c&"
import script from "./lessonsTab.vue?vue&type=script&lang=js&"
export * from "./lessonsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports